module.exports = __webpack_public_path__ + "static/media/icon_checkbox_checked.a64f1cd9.svg";